import { Component, OnInit, AfterViewInit, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { ProviderSidebarComponent } from '../sidebar/provider-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { ManageContributionComponent } from '../../shared/components/manage-contribution/manage-contribution.component';
import { CatalogueApiService } from '@angular-workspace/services';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-provider-manage-contribution',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    ProviderSidebarComponent,
    PageHeaderComponent,
    ManageContributionComponent,
  ],
  templateUrl: './manage-contribution.component.html',
  styleUrl: './manage-contribution.component.scss',
})
export class ProviderManageContributionComponent implements OnInit, AfterViewInit {
  @ViewChild(ManageContributionComponent) manageContributionComponent!: ManageContributionComponent;
  
  private catalogueApiService = inject(CatalogueApiService);
  private keycloak = inject(KeycloakService);

  async ngOnInit(): Promise<void> {
    // Data loading moved to ngAfterViewInit to ensure ViewChild is available
  }

  async ngAfterViewInit(): Promise<void> {
    await Promise.resolve();
    await this.waitForKeycloakReady();
    await this.loadAssets();
  }

  private async waitForKeycloakReady(): Promise<void> {
    try {
      const keycloakInstance = this.keycloak.getKeycloakInstance();
      if (keycloakInstance?.authenticated && keycloakInstance?.token) {
        return;
      }
      const maxWaitTime = 5000;
      const checkInterval = 100;
      const startTime = Date.now();
      while (Date.now() - startTime < maxWaitTime) {
        const instance = this.keycloak.getKeycloakInstance();
        if (instance?.authenticated && instance?.token) {
          return;
        }
        await new Promise(resolve => setTimeout(resolve, checkInterval));
      }
    } catch (error) {
      console.error('Error waiting for Keycloak:', error);
    }
  }

  async loadAssets(page: number = 1, size: number = 10, sort: string = 'itemCreatedAt:desc'): Promise<void> {
    try {
      const assetsData = await this.catalogueApiService.getAssets(page, size, sort);
      console.log('Assets loaded:', assetsData);
      
      // Map the response to the table data
      if (this.manageContributionComponent) {
        this.manageContributionComponent.mapMyAssetsResponse(assetsData);
      }
    } catch (error) {
      console.error('Error loading assets:', error);
    }
  }

  async reloadMyAssets(filterPayload?: any[]): Promise<void> {
    try {
      const myAssets = await this.catalogueApiService.getMyAssets(filterPayload);
      console.log('My assets loaded:', myAssets);
      
      // Map the response to the table data
      if (this.manageContributionComponent) {
        this.manageContributionComponent.mapMyAssetsResponse(myAssets);
      }
    } catch (error) {
      console.error('Error loading my assets:', error);
    }
  }

  onFilterChange(filterPayload: any[]): void {
    // Reload data with filter payload
    this.reloadMyAssets(filterPayload);
  }

  onRequestData(event: { page: number; pageSize: number; sort: string }): void {
    this.loadAssets(event.page, event.pageSize, event.sort);
  }
}
